import $ from "jquery";

const init = () => {
  initListener();
};

const initListener = () => {
  if (!$(".wpml-container").length) return;

  $(".wpml-container").click(function(){
    $(".wpml-container").toggleClass("active");
  });
  
};

try {
  init();
} catch (error) {
  console.log(error);
}
